import React, { useEffect } from "react";
import { 
  // Navigate, 
  Route, 
  useNavigate 
} from "react-router-dom";

import { useProfile } from "../Hooks/UserHooks";
import useSkillListStore from "../zStore/skillListStore";
import useSkillGroupStore from "../zStore/skillGroupStore";
import useInterestListStore from "../zStore/interestListStore";
import useInterestGroupStore from "../zStore/interestGroupStore";
// import useUserAuthStore from "../zStore/userAuth";

const AuthProtected = (props) => {
  const { userProfile, loading } = useProfile();
  const { fetchSkillGroup } = useSkillGroupStore();
  const { fetchSkill } = useSkillListStore();
  const { fetchInterest } = useInterestListStore();
  const { fetchInterestGroup } = useInterestGroupStore();
  const navigate = useNavigate();

  /*
    redirect is un-auth access protected routes via url
    */

  // const { data } = useUserAuthStore();

  useEffect(() => {
    if (!userProfile && loading) {
      navigate("/login");
      // return <></>;
      //
      // return (
      //   <Navigate
      //     to={{ pathname: "/login", state: { from: props.location } }}
      //   />
      // );
    }
    fetchSkillGroup();
    fetchSkill();
    fetchInterest();
    fetchInterestGroup();
  }, [
    userProfile,
    loading,
    navigate,
    fetchSkillGroup,
    fetchSkill,
    fetchInterest,
    fetchInterestGroup,
  ]);

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
